import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-dashboard-power-production-card',
  templateUrl: './dashboard-power-production-card.component.html',
  styleUrls: ['./dashboard-power-production-card.component.scss']
})
export class DashboardPowerProductionCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('sales-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('sales-counts-spinner');
      this.showCounter = true;
      this.count = this.data.length;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('sales-counts-spinner');
    }
  }

}
